// removed by extract-text-webpack-plugin
module.exports = {"bestInfo":"common_bestInfo_uyVeg","recruitment":"common_recruitment_3bDq2","commonList":"common_commonList_2C6Tf","liOddBolrd":"common_liOddBolrd_1i1vt","liOddLR":"common_liOddLR_I_1Nz","oddBg":"common_oddBg_3TelM","busAreaTitle":"common_busAreaTitle_17O66","busareaContent":"common_busareaContent_CiHSE","busAreas":"common_busAreas_2EEVH","subTitle":"common_subTitle_a1UHJ","borderTwo":"common_borderTwo_36QUF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/baseInfo/common/common.scss
// module id = 399
// module chunks = 0